document.addEventListener('DOMContentLoaded', function() {
    // Function to check if the screen is mobile
    function isMobile() {
        // Define mobile screen width range (example: 480px and below)
        return window.matchMedia("(max-width: 480px)").matches;
    }

    // Function to delete an element by its selector
    function deleteElement(selector) {
        var element = document.querySelector(selector);
        if (element) {
            element.remove();
        }
    }

    // Check if the screen is mobile and delete the element if true
    if (isMobile()) {
        deleteElement('.desktop-filter'); // Replace with your actual element selector
    }
});

$(document).ready(function() {
    var tagType = new URLSearchParams(window.location.search)
    try{
      var tagFilterValues = tagType.get('g').split(",");
      var selectedFilterValues = tagFilterValues;
      for(var i = 0; i < selectedFilterValues.length; i++){
        $(`#${selectedFilterValues[i]}Label`).attr("checked","true");  
        $(`#${selectedFilterValues[i]}Label`).parent("label").parent("li").addClass("selected");  
      }
      showSelectedFilter(selectedFilterValues);

      
    }catch(error){
      var selectedFilterValues = [];
    }
    $(".filterHeading").click(function(){
      $(".collectionFiltersBlock").click(function(e){
        e.stopPropagation();
      });
      $(this).parent('.filterBlock').toggleClass("activeFilter");
              // $('.filterBlock').addClass('activeFilter');

      $(`body`).toggleClass("hidden");
      
    });
    $(".collectionFilters li").click(function(){
      console.log($(this).find('input').is(':checked'));
      
      
      if ($(this).find('input').is(':checked')) {
        $(this).addClass("selected");
        $(this).find("input").attr("checked","true");
        var alreadyAdded = false;
        for(var i = 0; i < selectedFilterValues.length; i++){
          if($(this).find("input").val() == selectedFilterValues[i]){
            var alreadyAdded = true;
          }
        }
        if(alreadyAdded == false){
          selectedFilterValues.push($(this).find("input").val());
          var selectedFilterValuesStringify = selectedFilterValues.join(',');
          window.history.replaceState(null, null, `${window.location.origin}${window.location.pathname}?g=${selectedFilterValuesStringify}`);
          showSelectedFilter(selectedFilterValues);
          // console.log("selectedFilterValues", selectedFilterValues);
        }
      } else {
       
        // $(this).removeClass("selected");
        // $(this).find("input").removeAttr("checked","false");
        var alreadyAdded = false;
        for(var i = 0; i < selectedFilterValues.length; i++){
          if($(this).find("input").val() == selectedFilterValues[i]){
            var alreadyAdded = true;
            var filterIndex = i;
          }
        }
        if(alreadyAdded == true){
          selectedFilterValues.splice(filterIndex, 1);
          if(selectedFilterValues.length>0){
            var selectedFilterValuesStringify = selectedFilterValues.join(',');
            window.history.replaceState(null, null, `${window.location.origin}${window.location.pathname}?g=${selectedFilterValuesStringify}`);
            showSelectedFilter(selectedFilterValues);
          }else{
            window.history.replaceState(null, null, `${window.location.origin}${window.location.pathname}`);
              $(".selectedFilterBlock .selectedFilter").empty();
              // $(".clearAllFilterValues").hide();
            $(".selectedFiltersCount").html(`${selectedFilterValues.length}`);
            $(".filterProductsCount").empty(); 
            $("style#filterCss").empty();
            }
          // console.log("selectedFilterValues", selectedFilterValues);
        }
      }
    });
      $('.checkOuter input[name="tags"]').click(function(){
        var clearFilter=false;
        clearAllFilterFunction(clearFilter);
        var checkedFilterValue = $(this).val().replaceAll(" ","-").replaceAll("’","").toLowerCase();
        $(`#${checkedFilterValue}Label`).trigger("click");
        $(".customFilter").show();
        // console.log("checkedFilterValue", checkedFilterValue);
      })
    function showSelectedFilter(selectedFilterValues){
      $(".selectedFilterBlock .selectedFilter").empty();
      $(".selectedFiltersCount").html(`${selectedFilterValues.length}`);
      var filterProductCount = 0;
      var indexStore = [];
      for(var i = 0; i < selectedFilterValues.length; i++){
        // $(".clearAllFilterValues").show();
        $(".selectedFilterBlock .selectedFilter").append(`<li filter-value ="${selectedFilterValues[i]}"><input type="hidden" value="${selectedFilterValues[i]}"><span class="filterName">${selectedFilterValues[i].replaceAll("-"," ").toUpperCase()}</span><span class="removeFilterIcon"><i class="ion-close-round"></i></span></li>`)
        if(i == selectedFilterValues.length-1){
          $(".selectedFilterBlock .selectedFilter").append(`<li class="clearAllFilterValues">Clear All</li>`)
        }
        if( i == 0){
          for(var j = 0; j < productAllFilterValues.length; j++){
            // console.log(`productAllFilterValues`, productAllFilterValues[j]);
            var productAllFilterValue = productAllFilterValues[j].split(",");
            var filterAvailabilityCheck = false;
            for(var k = 0; k < productAllFilterValue.length; k++){
              var productAllFilterValueCheck = productAllFilterValue[k].replaceAll(" ","-").replaceAll("’","").toLowerCase();
              if(productAllFilterValueCheck == selectedFilterValues[i] && filterAvailabilityCheck == false){
                filterProductCount = filterProductCount + 1;
                filterAvailabilityCheck = true;
                indexStore.push(j);
              }
            }
          }
        }else{
          var recheckIndexStore = [];
          for(var l = 0; l < productAllFilterValues.length; l++){
            for(var m = 0; m < indexStore.length; m++){
              if(l==indexStore[m]){
                // conosle.log("productAllFilterValues",productAllFilterValues[l]);
                var productAllFilterValueRecheck = productAllFilterValues[l].split(",");
                var filterAvailabilityCheckRecheck = false;
                for(var n = 0; n < productAllFilterValueRecheck.length; n++){
                  var productAllFilterValueCheckRecheck = productAllFilterValueRecheck[n].replaceAll(" ","-").replaceAll("’","").toLowerCase();
                  if(productAllFilterValueCheckRecheck == selectedFilterValues[i] && filterAvailabilityCheckRecheck == false){
                    filterProductCount = filterProductCount + 1;
                    filterAvailabilityCheckRecheck = true;
                    recheckIndexStore.push(l);
                  }
                }
                if(m == indexStore.length-1){
                  indexStore = recheckIndexStore;
                }
              }
            }
          }
        }
      }
      if(selectedFilterValues.length>0){
        $(".filterProductsCount").html(`${indexStore.length} of`);
        let cssRules = selectedFilterValues
          .map((filter) => `.${filter} { display: block; }`)
          .join("\n");
        
        $("style#filterCss").html(`.productBlock{display:none} ${cssRules}`);
      }else{
        $("style#filterCss").empty();
        $(".filterProductsCount").empty();
      }     
    }
    $(document).on('click', '.removeFilterIcon', function() {
      $(`.${$(this).parent("li").find("input").val()}Label`).removeClass("selected");
      $(`.${$(this).parent("li").find("input").val()}Label`).find("input").removeAttr("checked","false");
      var alreadyAdded = false;
      for(var i = 0; i < selectedFilterValues.length; i++){
        if($(`.${$(this).parent("li").find("input").val()}Label`).find("input").val() == selectedFilterValues[i]){
          var alreadyAdded = true;
          var filterIndex = i;
        }
      }
      if(alreadyAdded == true){
        selectedFilterValues.splice(filterIndex, 1);
        if(selectedFilterValues.length>0){
          var selectedFilterValuesStringify = selectedFilterValues.join(',');
          window.history.replaceState(null, null, `${window.location.origin}${window.location.pathname}?g=${selectedFilterValuesStringify}`);
          showSelectedFilter(selectedFilterValues);
        }else{
          window.history.replaceState(null, null, `${window.location.origin}${window.location.pathname}`);
            $(".selectedFilterBlock .selectedFilter").empty();
            // $(".clearAllFilterValues").hide();
          $(".filterProductsCount").empty(); 
          $("style#filterCss").empty();
          }
        // console.log("selectedFilterValues", selectedFilterValues);
      }
      $(`.filterBlock`).removeClass("activeFilter");
      $(".selectedFiltersCount").html(`${selectedFilterValues.length}`);
      $(`body`).removeClass("hidden");
    });
    $(document).on('click', '.clearAllFilterValues', function() {
        var clearFilter=true;
        clearAllFilterFunction(clearFilter);
    });
    $(".selectedFiltersResetButton").click(function(){
        var clearFilter=true;
        clearAllFilterFunction(clearFilter);
    })
    function clearAllFilterFunction(clearFilter){
      $(".selectedFilterBlock .selectedFilter").empty();
      $(".filterProductsCount").empty();
      $("style#filterCss").empty();
      // $(".clearAllFilterValues").hide();
      window.history.replaceState(null, null, `${window.location.origin}${window.location.pathname}`);
      $(`.collectionFilters input`).removeAttr("checked","true");  
      $(`.collectionFilters li`).removeClass("selected");
      $(`.filterBlock`).removeClass("activeFilter");
      $(".selectedFiltersCount").html("0");
      $(`body`).removeClass("hidden");
      selectedFilterValues=[];
      $('.checkOuter input[name="tags"]').prop('checked', false);
    }
    $(document).on('click', function (event) {
      if (!$(event.target).closest('.filterBlock').length && !$(event.target).closest('.selectedFilterBlock').length) {
        $(`.filterBlock`).removeClass("activeFilter");
        
        $(`body`).removeClass("hidden");
      }
    });
  });